import {Injectable, Renderer2, RendererFactory2} from '@angular/core';

@Injectable()
export class ChatbotProvider {
  private renderer: Renderer2;

  constructor(rendererFactory: RendererFactory2) {
    this.renderer = rendererFactory.createRenderer(null, null);
  }

  public init(): void {
    this.loadScript('https://static.zdassets.com/ekr/snippet.js?key=0d3bba76-2418-4e97-a382-884903f32ba5', () => {
      console.log('Script loaded successfully');
    });
  }

  public hide(): void {
    // Find all div elements
    const allDivs: NodeListOf<HTMLDivElement> = document.querySelectorAll('div');

    // Loop through all div elements to find the one with style="visibility: visible;"
    for (let i = 0; i < allDivs.length; i++) {
      const div: HTMLDivElement = allDivs.item(i);

      if (div.style.visibility === 'visible') {
        // Set the display property to 'none'
        div.style.display = 'none';
        break; // Exit the loop after finding the first matching div
      }
    }
  }

  public show(): void {
    // Find all div elements
    const allDivs: NodeListOf<HTMLDivElement> = document.querySelectorAll('div');

    // Loop through all div elements to find the one with style="visibility: visible;"
    for (let i = 0; i < allDivs.length; i++) {
      const div: HTMLDivElement = allDivs.item(i);

      if (div.style.visibility === 'visible') {
        // Set the display property to 'none'
        div.style.display = 'initial';
        break; // Exit the loop after finding the first matching div
      }
    }
  }

  private loadScript(src: string, callback: () => void) {
    const script = this.renderer.createElement('script');
    script.type = 'text/javascript';
    script.src = src;
    script.id = 'ze-snippet';
    script.onload = callback;
    script.onerror = () => {
      console.error('Script failed to load');
    };
    this.renderer.appendChild(document.head, script);
  }

}



// WEBPACK FOOTER //
// ./src/providers/chatbot/chatbot.ts